<template>
  <div class="incenters">
    <div style>
      <Commonbtn backgroundColor="#FFF" title="查看" fontSize="14px" @btnclick="See" :src="require('@/assets/icon/look.png')" :optional="(handleList.length === 0 && !rowboo) || handleList.length > 1"></Commonbtn>
      <Commonbtn backgroundColor="#FFF" v-if="qx.approval" title="审批通过" fontSize="14px" @btnclick="Approved('Approveds')" :src="require('@/assets/channel/Approved.png')" :optional="handleList.length === 0"></Commonbtn>
      <Commonbtn backgroundColor="#FFF" v-if="qx.approval" title="审批驳回" fontSize="14px" @btnclick="Rejectapproval('Rejectapprovals')" :src="require('@/assets/channel/Rejectapproval.png')" :optional="handleList.length === 0"></Commonbtn>
      <Commonbtn backgroundColor="#FFF" title="审批流程" fontSize="14px" @btnclick="Approvalprocess" :src="require('@/assets/channel/Approvalprocess.png')" :optional="(handleList.length === 0 && !rowboo) || handleList.length > 1"></Commonbtn>
    </div>
    <!-- style="border: 1px solid blue;" -->
    <div class="TableWidth" v-if="CusTypestate == 1">
      <Commontable ref="ProviderRef" @cz="cz" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick" colnum="522" :tableData="tableData" :headerData="headerData" height="100%"></Commontable>
      <div class="pagination">
        <Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total"></Pagination>
      </div>
    </div>
    <div class="TableWidth" v-else-if="CusTypestate == 0">
      <Commontable ref="ProviderRef" @cz="cz" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick" colnum="522" :tableData="tableData" :headerData="headerDataTow" height="100%"></Commontable>
      <div class="pagination">
        <Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total"></Pagination>
      </div>
    </div>
    <DialogFrom width="1000px" title="查看" :loading="loading" :dialogVisible="dialogVisiblesSee" @cancel="cancelSee" @dialogOK="dialogOKSee">
      <div class="from" style="overflow-y: scroll;height: 500px;">
        <template v-for="(item , index) of fromdataedit">
          <Commondropdownlist ref="DsphFEditref" :event="item.event" :disabledHB="item.disabled" :disabled="item.disabled" :radio="item.radio" :key="index" :widths="item.widths" :options="item.options" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max"></Commondropdownlist>
        </template>
        <div></div>
        <div style="margin-left: 5px;margin-top: 10px;display: inline-block;">查看图片：</div>
        <!-- <CommonUploadEnclosure @getFiles="getFileDsphImg" types="multiple" style="height: 120px;"></CommonUploadEnclosure> -->
        <!-- <div class="uploadImg">
          <div v-for="(item,index) of ImageUrl" :key="index+'update'" style=" display: inline-block;overflow: hidden;">
            <img src="../../../../assets/channel/firstbusiness/phontsD.png" alt="" class="See_icon" @click="Seeicon(item)">
            <img :src="`${ item }`" alt="" class="imgBJ">
            <div class="DelOrSee"></div>
          </div>
        </div>-->
        <div class="SMSProviderFlex">
          <FilesAndPictures class="FilesAndPictures" :DelFlag="false" v-for="(item , index) of SMSProviderUploadData" :key="index" :fileAddImgData="item" @See="Look" @Del="Del"></FilesAndPictures>
        </div>
      </div>
      <div class="SeeBtn">
        <Commonbtn backgroundColor="#FFF" v-if="qx.approval" title="审批通过" fontSize="14px" @btnclick="Approved('See')" :src="require('@/assets/channel/Approved.png')"></Commonbtn>
        <Commonbtn backgroundColor="#FFF" v-if="qx.approval" title="审批驳回" fontSize="14px" @btnclick="Rejectapproval('See')" :src="require('@/assets/channel/Rejectapproval.png')"></Commonbtn>
      </div>
    </DialogFrom>
    <DialogFrom width="1000px" title="驳回理由" :dialogVisible="dialogVisiblesReject" @cancel="cancelReject" @dialogOK="dialogOKReject">
      <div class="from" style="position: relative;overflow-y: scroll;height: 500px;">
        <el-input type="textarea" :rows="2" placeholder="请输入驳回理由" v-model="Rejecttextarea"></el-input>
      </div>
    </DialogFrom>
    <DialogFrom width="1000px" title="审批流程" :dialogVisible="dialogVisiblesprocess" @cancel="cancelprocess" @dialogOK="dialogOKprocess">
      <div class="from" style="position: relative;overflow-y: scroll;height: 500px;">
        <Commontable ref="ProviderRef" @onRowClick="onRowClick" :loadingTable="loadingTableprocess" width="1000px" colnum="7" :tableData="tableDataprocess" :headerData="headerDataprocess" height="100%"></Commontable>
      </div>
    </DialogFrom>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleApproved" @cancel="cancelApproved" @dialogOK="dialogOKApproved" :src="require('@/assets/icon/icon-errors.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要审批通过这条档案吗？</span>
    </Dialog>
    <DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg" @dialogOK="dialogOKdrjg">
      <div class="from">
        <Commontable @onRowClick="onRowClick" width="830px" colnum="100" :tableData="tableDatadrjg" height="100%"></Commontable>
      </div>
    </DialogFrom>
    <Commonpictureswitching :show="show" @hidefn="hidefn" :picImages="picImages"></Commonpictureswitching>
    <Prviwe :show="shows" @hidefn="hidefns" :imgsrc="imgsrc"></Prviwe>
  </div>
</template>
<script>
import Commondropdownlist from "../../../../components/common-dropdownlist.vue";
import Prviwe from "../../../../components/picturepreview.vue";
import Commontable from "../../../../components/common-table.vue";
import Commonbtn from "../../../../components/common-btn.vue";
import Pagination from "../../../../components/pagination.vue";
import DialogFrom from "../../../../components/dialog-from.vue";
import FilesAndPictures from "@/components/FilesAndPictures.vue";
import fromdata from "../fromData/add";
import fromdataedit from "../fromData/edit";
import Dialog from "../../../../components/dialog.vue";
import Commondown from "../../../../components/common-down.vue";
import CommonbtnUpLoad from "../../../../components/common-upload.vue";
import Commonpictureswitching from "../../../../components/common-pictureswitching.vue";
import CommonUploadEnclosure from "../../../../components/common-upload-Enclosure.vue";
import {
  CusRelationProviderGetInvoicePic,
  AppRelationProviderApprove,
  APPRelationProviderReject,
  APPRelationProviderGetHostory,
  APPRelationProviderInfo,
  CusType
} from "@/api/home";
export default {
  components: {
    Commontable,
    Commonbtn,
    Pagination,
    DialogFrom,
    Commondropdownlist,
    Dialog,
    Commondown,
    CommonbtnUpLoad,
    Commonpictureswitching,
    CommonUploadEnclosure,
    Prviwe,
    FilesAndPictures
  },
  props: {
    tableData: {
      type: Array,
      default: []
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
      dialogVisiblesprocess: false,
      dialogVisiblesReject: false,
      dialogVisibleApproved: false,
      dialogVisiblesSee: false,
      rowboo: false,
      dialogVisiblesdrjg: false,
      rightboo: false,
      loading: false,
      show: false,
      shows: false,
      loadingTableprocess: true,
      title: "结果",
      CusTypestate: "0",
      Rejecttextarea: "",
      ApprovedType: "",
      RejectapprovalType: "",
      ID: "",
      imgsrc: "",
      ptype: "",
      handleList: [],
      FileName: [],
      ImageUrl: [],
      fromdataedit: [],
      tableDatadrjg: [],
      tableDataprocess: [],
      SMSProviderUploadData: [],
      headerDataprocess: [
        {
          prop: "id",
          label: "序号",
          columnwidth: 50
        },
        {
          prop: "TrueName",
          label: "审批人",
          columnwidth: 200
        },
        {
          prop: "MustAllText",
          label: "流转规则",
          columnwidth: 200
        },
        {
          prop: "ApprovedUserName",
          label: "已审批人",
          columnwidth: 200
        },
        {
          prop: "CompletedText",
          label: "是否完结",
          columnwidth: 173
        },
        {
          prop: "ApprovalTime",
          label: "审批时间",
          columnwidth: 120
        }
      ],
      headerDataTow: [
        {
          prop: "id",
          label: "序号",
          columnwidth: 50
        },
        {
          prop: "CreatorName",
          label: "创建人",
          columnwidth: 160
        },
        {
          prop: "InvClassName",
          label: "产品线",
          columnwidth: 80
        },
        {
          prop: "OperateName",
          label: "操作",
          columnwidth: 100
        },
        {
          prop: "StatusName",
          label: "状态",
          columnwidth: 90
        },
        {
          prop: "RejectReason",
          label: "驳回原因",
          columnwidth: 150
        },
        {
          prop: "TXCusName",
          label: "下级经销商",
          columnwidth: 230
        },
        {
          prop: "ProviderName",
          label: "指定配送商/采购代理",
          columnwidth: 160
        },
        {
          prop: "HPName",
          label: "医院名称",
          columnwidth: 160
        },
        {
          prop: "Remark",
          label: "备注",
          columnwidth: 160
        },
        {
          prop: "VouchValiDate",
          label: "备案有效期",
          columnwidth: 120
        },
        {
          prop: "CreateTime",
          label: "创建开始时间",
          columnwidth: 150,
          options: {
            type: "备案"
          }
        },
        {
          prop: "RejecterName",
          label: "驳回人",
          columnwidth: 170
        },
        {
          prop: "RejectTime",
          label: "驳回时间",
          columnwidth: 120
        },
        {
          prop: "UpdaterName",
          label: "修改人",
          columnwidth: 160
        },
        {
          prop: "UpdateTime",
          label: "修改时间",
          columnwidth: 120
        },
        {
          prop: "ID",
          label: "申请单号",
          columnwidth: 170
        }
        // {
        //   prop: 'Activor',
        //   label: '停启用人',
        //   columnwidth: 230
        // },

        // {
        //   prop: 'ActiveTime',
        //   label: '停启用时间',
        //   columnwidth: 160
        // },
      ],
      headerData: [
        {
          prop: "id",
          label: "序号",
          columnwidth: 50
        },
        {
          prop: "CreatorName",
          label: "创建人",
          columnwidth: 160
        },
        {
          prop: "InvClassName",
          label: "产品线",
          columnwidth: 80
        },
        {
          prop: "OperateName",
          label: "操作",
          columnwidth: 100
        },
        {
          prop: "StatusName",
          label: "状态",
          columnwidth: 90
        },
        {
          prop: "RejectReason",
          label: "驳回原因",
          columnwidth: 150
        },
        {
          prop: "CusName",
          label: "经销商名称",
          columnwidth: 220
        },
        {
          prop: "TXCusName",
          label: "下级经销商",
          columnwidth: 230
        },
        {
          prop: "ProviderName",
          label: "指定配送商/采购代理",
          columnwidth: 160
        },
        {
          prop: "HPName",
          label: "医院名称",
          columnwidth: 160
        },
        {
          prop: "Remark",
          label: "备注",
          columnwidth: 160
        },
        {
          prop: "VouchValiDate",
          label: "备案有效期",
          columnwidth: 120
        },
        {
          prop: "CreateTime",
          label: "创建开始时间",
          columnwidth: 150,
          options: {
            type: "备案"
          }
        },
        {
          prop: "RejecterName",
          label: "驳回人",
          columnwidth: 170
        },
        {
          prop: "RejectTime",
          label: "驳回时间",
          columnwidth: 120
        },
        {
          prop: "UpdaterName",
          label: "修改人",
          columnwidth: 160
        },
        {
          prop: "UpdateTime",
          label: "修改时间",
          columnwidth: 120
        },
        {
          prop: "ID",
          label: "申请单号",
          columnwidth: 170
        }
        // {
        //   prop: 'ProviderType',
        //   label: '停启用人',
        //   columnwidth: 230
        // },

        // {
        //   prop: 'HasHPInvoiceName',
        //   label: '停启用时间',
        //   columnwidth: 160
        // },
      ],
      picImages: [],
      qus: [],
      qx: {
        add: false,
        update: false,
        del: false,
        stopif: true,
        daoc: true,
        assignment: false,
        enabled: false,
        submit: false,
        skip: false, //跳过
        reset: false, //重置
        setting: false,
        approval: false
      }
    };
  },
  created() {
    this.CusType();
  },
  mounted() {
    this.fromdataadd = JSON.parse(JSON.stringify(fromdata));
    this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit));
  },
  methods: {
    // 判断一二级经销商
    async CusType() {
      let { code, data } = await CusType({});
      if (code == 0) {
        if (data.CusType == "经销商") {
          this.CusTypestate = 0;
        } else {
          this.CusTypestate = 1;
        }
      }
    },
    async cusRelationProviderGetInvoicePic(id) {
      let { code, data } = await CusRelationProviderGetInvoicePic({
        ID: id
      });
      if (code == 0) {
        this.picImages = data.picImages;
      }
    },
    cz(ID) {
      this.cusRelationProviderGetInvoicePic(ID);
      this.show = true;
    },
    hidefn() {
      this.show = false;
    },
    hidefns() {
      this.shows = false;
    },
    Delicon(index) {
      this.ImageUrl.splice(index, 1);
      if (this.stateDelIcon == "update") {
        this.FileName.splice(index, 1);
        //console.log(this.FileName, 'FileName');
      }
    },
    Seeicon(URL) {
      this.shows = true;
      this.imgsrc = URL;
    },

    // 审批通过
    async AppRelationProviderApprove() {
      let arr = [];
      this.handleList.map((item, index) => {
        arr.push(item.ID);
      });
      console.log(this.ApprovedType, "ApprovedType");
      console.log(arr);
      // return false;
      let { code, data, message } = await AppRelationProviderApprove({
        IDs: this.ApprovedType == "See" ? [this.ID] : arr
      });

      if (code == 0) {
        this.$message({
          type: "success",
          message: "审批通过"
        });
        // this.dialogVisiblesdrjg = true
        // this.tableDatadrjg = data
        // this.title = "审批结果"
        this.dialogVisibleApproved = false;
        this.rowboo = false;
        this.handleList.length = 0;
        this.$refs.ProviderRef.$refs.fileTableSelect.clearSelection();
        this.handleList = [];
        this.$parent.APPRelationProviderList();
      } else if (code == 101) {
        this.$message({
          type: "warning",
          message: message
        });
      } else if (code == 1) {
        this.dialogVisiblesdrjg = true;
        this.tableDatadrjg = data;
        this.title = "审批结果";
        this.dialogVisibleApproved = false;
      } else {
        this.$message({
          type: "error",
          message: message
        });
      }
    },
    onRowClick(val) {
      this.ID = val.ID;
      this.rowboo = true;
      //console.log('val', val)
    },

    Approved(type) {
      console.log(type, "type");
      if (type == "See") {
        if (this.ID == "" || this.ID == null || this.ID == undefined) {
          this.$message({
            type: "error",
            message: "请选择要审批通过的数据！"
          });
          return;
        }
        this.dialogVisibleApproved = true;
        this.ApprovedType = "See";
        return;
      }

      if (type == "Approveds") {
        if (this.handleList.length <= 0) {
          this.$message({
            type: "error",
            message: "请选择要审批通过的数据(多选)！"
          });
          return;
        }
        this.dialogVisibleApproved = true;
        this.ApprovedType = "Approveds";
        return;
      }
    },

    cancelApproved() {
      this.dialogVisibleApproved = false;
    },
    dialogOKApproved() {
      this.AppRelationProviderApprove();
    },

    // 驳回
    async APPRelationProviderReject() {
      let arr = [];
      this.handleList.map((item, index) => {
        arr.push(item.ID);
      });
      let { code, data, message } = await APPRelationProviderReject({
        IDs: this.RejectapprovalType == "See" ? [this.ID] : arr,
        RejectReason: this.Rejecttextarea
      });
      if (code == 0) {
        this.$message({
          type: "success",
          message: "驳回成功"
        });
        this.dialogVisiblesReject = false;
        this.$parent.APPRelationProviderList();
        this.rowboo = false;
        this.handleList.length = 0;
        this.$refs.ProviderRef.$refs.fileTableSelect.clearSelection();
        this.dialogVisiblesReject = false;
      } else if (code == 101) {
        this.$message({
          type: "warning",
          message: message
        });
      } else if (code == 1) {
        this.dialogVisiblesdrjg = true;
        this.tableDatadrjg = data;
        this.title = "驳回结果";
      } else {
        this.$message({
          type: "error",
          message: message
        });
      }
    },
    Rejectapproval(type) {
      console.log(type, "type");
      if (type == "See") {
        if (this.ID == "" || this.ID == null || this.ID == undefined) {
          this.$message({
            type: "error",
            message: "请选择要驳回的数据！"
          });
          return;
        }
        this.dialogVisiblesReject = true;
        this.RejectapprovalType = "See";
        return;
      }
      if (type == "Rejectapprovals") {
        if (this.handleList.length <= 0) {
          this.$message({
            type: "error",
            message: "请选择要驳回的数据(多选)！"
          });
          return;
        }
        this.dialogVisiblesReject = true;
        this.RejectapprovalType = "Rejectapprovals";
        return;
      }
    },
    cancelReject() {
      this.dialogVisiblesReject = false;
    },
    dialogOKReject() {
      this.APPRelationProviderReject();
    },
    // 审批流程
    async APPRelationProviderGetHostory() {
      this.loadingTableprocess = true;
      let { code, data, message } = await APPRelationProviderGetHostory({
        ID: this.ID
      });
      if (code == 0) {
        if (data.length > 0) {
          this.tableDataprocess = data;
          this.dialogVisiblesprocess = true;
        } else {
          this.$message.warning("暂无审批流程数据！");
        }
      } else {
        this.$message.warning(message);
      }
      this.loadingTableprocess = false;
    },
    Approvalprocess() {
      if (this.handleList.length === 1) {
        this.ID = this.handleList[0].ID;
        this.rowboo = true;
      }
      if (this.rowboo == true) {
        this.APPRelationProviderGetHostory();
        return;
      }
      this.$message({
        type: "error",
        message: "请选择要操作的数据！"
      });
    },
    cancelprocess() {
      this.dialogVisiblesprocess = false;
    },
    dialogOKprocess() {
      this.dialogVisiblesprocess = false;
    },
    // 详情
    async APPRelationProviderInfo() {
      const loading = this.$loading({
        lock: true,
        text: "正在加载详情中...",
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,0.3)"
      });
      let { code, message, data } = await APPRelationProviderInfo({
        ID: this.ID
      });
      if (code == 0) {
        this.fromdataedit[0].inputdata = data.InvClass;
        this.fromdataedit[1].inputdata = data.CusName;
        // this.fromdataedit[2].inputdata = data.ProviderType
        this.fromdataedit[2].inputdata = data.TXCusName;
        this.fromdataedit[3].inputdata = data.ProviderName;
        this.fromdataedit[4].inputdata = data.HPName;
        this.fromdataedit[5].inputdata = data.VouchValiDate;
        this.fromdataedit[6].inputdata = data.Remark;
        this.fromdataedit[7].radio = data.HasHPInvoice + "";
        this.ImageUrl = [];
        this.FileName = [];
        if (data.lstImages) {
          data.lstImages.map((item, index) => {
            this.SMSProviderUploadData.push(item);
            this.ImageUrl.push(item.ImageUrlPath);
            this.FileName.push(item.ImagePath);
          });
        }
        // this.InvClassCodeName = data.CusName
        // this.HPidName = data.ProviderName
        // this.HospHPidName = data.HPName
        // this.InvClassCode = data.CusCode
        // this.TXCusName = data.TXCusName
        // this.TXCusID = data.TXCusID
        // this.HPid = data.ProviderID
        // this.HospHPid = data.Hospital
        this.dialogVisiblesSee = true;
      } else {
        this.$message.warning(message);
      }
      loading.close();
    },
    Look(par) {
      if (
        par.Extension == "jpg" ||
        par.Extension == "png" ||
        par.Extension == "gif"
      ) {
        this.shows = true;
        this.imgsrc = par.ImageUrl;
      } else if (par.Extension == "pdf") {
        window.open(par.ImageUrl, "_blank");
      } else {
        window.location.href = par.ImageUrl;
      }
    },
    Del(fileAddImgData, index) {
      this.SMSProviderUploadData.splice(index, 1);
    },
    See() {
      if (this.handleList.length === 1) {
        this.ID = this.handleList[0].ID;
      }
      if (!this.ID) {
        this.$message({
          type: "error",
          message: "请选择要查看的数据！"
        });
        return;
      }
      this.APPRelationProviderInfo();
    },
    cancelSee() {
      this.dialogVisiblesSee = false;
    },
    dialogOKSee() {
      this.dialogVisiblesSee = false;
    },
    handleCurrentChange(pageindex) {
      this.$emit("handleCurrentChange", pageindex);
    },
    handleSizeChange(paegSzie) {
      this.$emit("handleSizeChange", paegSzie);
    },
    handleSelectionChange(val) {
      this.handleList = val;
    },
    canceldrjg() {
      this.dialogVisiblesdrjg = false;
    },
    dialogOKdrjg() {
      this.dialogVisiblesdrjg = false;
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        let data = JSON.parse(localStorage.getItem("MenusData"));
        data.Menus.forEach((item, index) => {
          if (item.NodeID == 9) {
            item.Nodes.forEach((items, indexs) => {
              if (items.NodeID == to.query.NodeID) {
                items.Nodes.forEach((itemes, indexes) => {
                  if (itemes.NodeID == to.query.MenuID) {
                    this.qus = itemes.Nodes;
                  }
                });
              }
            });
          }
        });
        console.log(this.qus, "qus");
        if (this.qus) {
          this.qus.map((item, index) => {
            if (item.NodeName == "add") {
              this.qx.add = true;
            } else if (item.NodeName == "edit") {
              this.qx.update = true;
            } else if (item.NodeName == "delete") {
              this.qx.del = true;
            } else if (item.NodeName == "stopif") {
              this.qx.del = true;
            } else if (item.NodeName == "assignment") {
              this.qx.assignment = true;
            } else if (item.NodeName == "enabled") {
              this.qx.enabled = true;
            } else if (item.NodeName == "skip") {
              this.qx.skip = true;
            } else if (item.NodeName == "reset") {
              this.qx.reset = true;
            } else if (item.NodeName == "setting") {
              this.qx.setting = true;
            } else if (item.NodeName == "submit") {
              this.qx.submit = true;
            } else if (item.NodeName == "approval") {
              this.qx.approval = true;
            }
          });
        }
      },
      deep: true,
      immediate: true
    },
    dialogVisiblesSee: {
      handler(newDialogSee, oldDialogSee) {
        console.log(newDialogSee);
        if (!newDialogSee) {
          this.ImageUrl = [];
          this.FileName = [];
          this.SMSProviderUploadData = []
        }
      }
    },
    dialogVisiblesReject: {
      handler(newVal, oldVal) {
        if (!newVal) {
          this.Rejecttextarea = "";
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.FilesAndPictures {

}
.SMSProviderFlex {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.incenters {
  height: 100%;

  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
    padding-bottom: 16px;
  }

  // div {
  //   margin-left: 8px;
  //   margin-right: 8px;
  //   margin-top: 5px;
  //   margin-bottom: 5px;

  // }

  .from {
    width: 100%;
  }

  .signingroles {
    height: 500px;
    width: 100%;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // border: 1px solid red;

    .left {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
    }

    .right {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
      // pointer-events: none;
    }
  }
}

.right-s {
  position: absolute;
  z-index: 99;
  opacity: 0.5;
  right: 21px;
  width: 470px;
  height: 240px;
  background-color: #ffffff;
  cursor: no-drop;
}

.dwonleft {
  width: 170px;
  height: 48px;
  position: absolute;
  background-color: #ffffff;
  z-index: 99;
  right: 350px;
  top: 322px;
  text-align: center;
  line-height: 48px;
  color: #333333;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  font-size: 14px;
  cursor: pointer;
}

.dwonleft:hover {
  background-color: #f0f0f0;
}
.imgBJ {
  width: 120px;
  height: 120px;
  position: relative;
  // top: 38px;
  margin-left: 20px;
  border: 1px solid #c1c5ca;
}
.uploadImg {
  // width: 800px;
  // border: 1px solid red;
  display: inline-block;
  vertical-align: top;
  margin-left: -35px;
  margin-top: 13px;
}
.DelOrSee {
  width: 120px;
  height: 120px;
  display: inline-block;
  background-color: #000;
  opacity: 0.2;
  position: relative;
  margin-left: -120px;
}
.del_icon {
  position: relative;
  left: 80px;
  top: -50px;
  z-index: 99;
  cursor: pointer;
}
.See_icon {
  position: relative;
  left: 87px;
  top: -54px;
  z-index: 99;
  cursor: pointer;
}
.SeeBtn {
  margin: 0 auto;
  width: 500px;
  // border: 1px solid;
  display: flex;
  justify-content: space-around;
}
</style>
